module.exports = __webpack_public_path__ + "img/q50-20.412bab52.png";